export default "__VITE_ASSET__CwHG0Sc7__"